import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-general-view-layout',
    styleUrls: ['./general-view-layout.component.scss'],
    templateUrl: './general-view-layout.component.html',
})
export class GeneralViewLayoutComponent {}
